import React, { Component } from 'react'
import { connect } from 'react-redux';
import config from '../config';
import common from '../common';
import AdBottom from './AdBottom';
import { getLandingTrans } from '../actions/AppActions';
import trackEventsObj from '../constants/new-pageTrackEvents'
import { Redirect } from 'react-router-dom';

class LandingPage extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
    this.onLogin = this.onLogin.bind(this);
    // this.tryAsGuest = this.tryAsGuest.bind(this);
    this.goToAppSection = this.goToAppSection.bind(this);
    this.goToPlayStore = this.goToPlayStore.bind(this);
    this.goToAppStore = this.goToAppStore.bind(this);
  }

  componentWillMount() {
    this.props.getLandingTrans()
  }

  componentDidMount() {
    if (document.getElementById('billboard')) {
      document.getElementById('billboard').classList.add('si-display-none');
    }

    let visit = this.getVisitNo();
    if (visit) {
      switch (visit) {
        case 1:
          common.pageViewTracking("/uclfantasy/landing/1st", trackEventsObj["landingPage1"]);
          break;
        case 2:
          common.pageViewTracking("/uclfantasy/landing/2nd", trackEventsObj["landingPage2"]);
          break;
        case 3:
          common.pageViewTracking("/uclfantasy/landing/3rd", trackEventsObj["landingPage3"]);
          break;
      }
    }
  }

  componentWillUnmount() {
    if (document.getElementById('billboard')) {
      document.getElementById('billboard').classList.remove('si-display-none');
    }
  }

  onLogin() {
    let visitNo = this.getVisitNo();
    if (visitNo) {
      switch (visitNo) {
        case 1:
          common.customTracking('Visit ' + visitNo + ' - Login and Play', "/uclfantasy/landing/1st");
          break;
        case 2:
          common.customTracking('Visit ' + visitNo + ' - Login and Play', "/uclfantasy/landing/2nd");
          break;
        case 3:
          common.customTracking('Visit ' + visitNo + ' - Login and Play', "/uclfantasy/landing/3rd");
          break;
      }
    }
    // common.customTracking('Visit ' + visitNo + ' - Login and Play', '');

    window.ucl_login_clicked = true
    // this.setPageVisitCount()
    window.uefaGHComponent.toogleMpsMenu();
  }

  tryAsGuest(isTryAsGuest) {
    let visitNo = this.getVisitNo();
    if (visitNo) {
      switch (visitNo) {
        case 1:
          if (isTryAsGuest) {
            common.customTracking('Visit ' + visitNo + ' - Try as Guest', "/uclfantasy/landing/1st");
          }
          else {
            common.customTracking('Visit ' + visitNo + ' - Play Fantasy', "/uclfantasy/landing/1st");
          }
          break;
        case 2:
          if (isTryAsGuest) {
            common.customTracking('Visit ' + visitNo + ' - Try as Guest', "/uclfantasy/landing/2nd");
          }
          else {
            common.customTracking('Visit ' + visitNo + ' - Play Fantasy', "/uclfantasy/landing/2nd");
          }
          break;
        case 3:
          if (isTryAsGuest) {
            common.customTracking('Visit ' + visitNo + ' - Try as Guest', "/uclfantasy/landing/3rd");
          }
          else {
            common.customTracking('Visit ' + visitNo + ' - Play Fantasy', "/uclfantasy/landing/3rd");
          }
          break;
      }
    }


    this.setPageVisitCount()
    // if(this.props.onClose){
    //     this.props.onClose()
    // }
    window.fromLandingPage = true
    return this.props.history.push('/create-team');
  }

  setPageVisitCount() {
    let visitNo = this.getVisitNo()
    let visitObj = common.getLocalStorage('visitedLandingPage') || {};
    let clientName = common.getClientNameFromLandingURL();
    visitObj[clientName] = visitNo;
    common.setLocalStorage('visitedLandingPage', visitObj)
  }

  goToAppSection() {
    let visitNo = this.getVisitNo()
    common.customTracking('Visit ' + visitNo + ' - Get App', '/uclfantasy/landing');
    common.scrollToElement("#appSection", -40)
  }

  getVisitNo() {
    let clientName = common.getClientNameFromLandingURL();
    let visitObj = common.getLocalStorage('visitedLandingPage')
    let visitNo = (visitObj ? visitObj[clientName] : 0)
    if (!visitNo) {
      visitNo = 1
    }
    else {
      visitNo += 1
    }
    return visitNo
  }

  getPageTitle() {
    let visitNo = this.getVisitNo(),
      result = { title: "", desc: "" },
      trans = this.props.landingTrans,
      cookie = common.getCookie(config.COOKIE_GM),
      CLIENT_NAME = common.getClientNameFromLandingURL(),
      transPrefix = (CLIENT_NAME == 'fantasy' ? '' : CLIENT_NAME + '_')

    if (cookie) {
      let cookieGM = common.parseCookie(cookie)
      switch (visitNo) {
        case 1:
          result.title = (trans[transPrefix + 'landingTitleLogin'] || "Hey {USER_NAME}, Play the official UEFA Champions League Fantasy game").replace('{USER_NAME}', decodeURIComponent(cookieGM.UserName))
          result.desc = (trans[transPrefix + 'landingDesc'] || "Compete against your friends, climb the global rankings and win exclusive prizes. All on football’s ultimate stage.")
          return result;
        case 2:
          result.title = (trans[transPrefix + 'landingTitle2Login'] || "Hey {USER_NAME}, Welcome back to fantasy football’s ultimate stage!").replace('{USER_NAME}', decodeURIComponent(cookieGM.UserName))
          result.desc = (trans[transPrefix + 'landingDesc2'] || "The official UEFA Champions League Fantasy game—compete against your friends, climb the global rankings and win exclusive prizes.")
          return result;
        case 3:
          result.title = (trans[transPrefix + 'landingTitle3Login'] || "Hey {USER_NAME}, Make each match count").replace('{USER_NAME}', decodeURIComponent(cookieGM.UserName))
          result.desc = (trans[transPrefix + 'landingDesc3'] || "The official UEFA Champions League Fantasy game—earn points, beat your friends and win exclusive prices.")
          return result;
        default:
          result.title = (trans[transPrefix + 'landingTitle3Login'] || "Hey {USER_NAME}, Make each match count").replace('{USER_NAME}', decodeURIComponent(cookieGM.UserName))
          result.desc = (trans[transPrefix + 'landingDesc3'] || "The official UEFA Champions League Fantasy game—earn points, beat your friends and win exclusive prices.")
          return result;
      }
    }
    else {
      switch (visitNo) {
        case 1:
          result.title = (trans[transPrefix + 'landingTitle'] || "Play the official UEFA Champions League Fantasy game")
          result.desc = (trans[transPrefix + 'landingDesc'] || "Compete against your friends, climb the global rankings and win exclusive prizes. All on football’s ultimate stage.")
          return result;
        case 2:
          result.title = (trans[transPrefix + 'landingTitle2'] || "Welcome back to fantasy football’s ultimate stage!")
          result.desc = (trans[transPrefix + 'landingDesc2'] || "The official UEFA Champions League Fantasy game—compete against your friends, climb the global rankings and win exclusive prizes.")
          return result;
        case 3:
          result.title = (trans[transPrefix + 'landingTitle3'] || "Make each match count")
          result.desc = (trans[transPrefix + 'landingDesc3'] || "The official UEFA Champions League Fantasy game—earn points, beat your friends and win exclusive prices.")
          return result;
        default:
          result.title = (trans[transPrefix + 'landingTitle3'] || "Make each match count")
          result.desc = (trans[transPrefix + 'landingDesc3'] || "The official UEFA Champions League Fantasy game—earn points, beat your friends and win exclusive prices.")
          return result;
      }

    }
  }



  goToPlayStore() {
    common.customTracking('Get App - Android', '/uclfantasy/landing');
    window.open("https://play.google.com/store/apps/details?id=com.uefa.eurofantasy")
  }

  goToAppStore() {
    common.customTracking('Get App - iOS', '/uclfantasy/landing');
    window.open("https://apps.apple.com/us/app/gaming-hub-uefa-champions-lea/id1107602457")
  }

  render() {
    let ImgUrl = config.playerImgBase,
      trans = this.props.landingTrans,
      cookie = common.getCookie(config.COOKIE_GM),
      cookieGM = common.parseCookie(cookie)

    if (!trans) {
      return null;
    }

    let titleObj = this.getPageTitle()
    const userToken = window.uefaGHComponent.getUserTokens();
    const registered = (userToken.registered);
    if (registered && window.ucl_login_clicked) {
      window.ucl_login_clicked = false
      window.fromLandingPage = true
      this.setPageVisitCount()
      // if(this.props.onClose){
      //   this.props.onClose()
      // }
      return <Redirect to='/create-team' />
    }
    let CLIENT_NAME = common.getClientNameFromLandingURL();
    let transPrefix = (CLIENT_NAME == 'fantasy' ? '' : CLIENT_NAME + '_')
    let imageBaseURL = config.landingPageImageBase.replace('{CLIENT_NAME}', CLIENT_NAME)


    return (
      <div className="si-main-component si-landing">
        <div className="si-section si-section--banner" style={ { backgroundImage: "url('" + imageBaseURL + "first-banner.jpg')" } }>
          <div className="si-section--container">
            <div className="si-section__row">
              <div className="si-section__col">
                <div className="si-head si-head--primary">{ titleObj.title }</div>
                <div className="si-section__desc">{ titleObj.desc }</div>
                <div className="si-btn__wrp">
                  {
                    (!cookie)
                      ?
                      <React.Fragment>
                        <div className="si-btn si-btn-primary" onClick={ this.onLogin }>{ trans[transPrefix + 'loginAndPlay'] || "Log in and play" }</div>
                        <div className="si-btn si-btn-secondary" onClick={ () => { this.tryAsGuest(true) } }>{ trans[transPrefix + 'tryAsGuest'] || "Try as a guest" }</div>
                      </React.Fragment>
                      :
                      <div className="si-btn si-btn-primary" onClick={ () => { this.tryAsGuest() } }>{ trans[transPrefix + 'playFantasy'] || "PLAY FANTASY" }</div>

                  }

                </div>
                <div className="si-section__link"><span>{ trans[transPrefix + 'orGetThe'] || "Or get the" } &nbsp;</span><a href="Javascript:void(0)" onClick={ this.goToAppSection } className="si-anchor">{ trans[transPrefix + 'uclGHApp'] || "UCL Gaming Hub app" }</a></div>

              </div>
              <div className="si-section__col">
                <div className="si-section__img" style={ { backgroundImage: "url('" + imageBaseURL + "first-banner-web.png?v=" + config.imgVersion + ")" } }></div>
                {/* <div className="si-ad-wrp">
                  <div className="si-bottom-ad">ad wrap</div>
                </div> */}
                <div className="si-ad-wrp">
                  {
                    (config.isMobile)
                      ?
                      <AdBottom />
                      :
                      null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="si-section si-section--plyrs">
          <div className="si-section--container">
            <div className="si-section__row">
              <div className="si-section__col">
                <div className="si-head si-head--secondary">{ trans[transPrefix + 'featuringFavPlayerTeam'] || "Featuring your favourite players & teams" }</div>

              </div>
            </div>
          </div>
        </div>
        <div className="si-section si-section--how-to">
          <div className="si-section--container">
            <div className="si-head si-head--tertiary">{ trans[transPrefix + 'becomePlayer'] || "Become a player" }</div>

            <div className="si-section__row si-first">
              <div className="si-section__col">
                <div className="si-intro__img">
                  <img src={ imageBaseURL + "pick-your-squad.png?v=" + config.imgVersion } />
                </div>
                <div className="si-intro__head">
                  { trans[transPrefix + 'pickYourSquad'] || "PICK YOUR SQUAD" }
                </div>
                <div className="si-intro__desc">
                  { trans[transPrefix + 'selectYourSquad'] || "Select your squad of 15 players using a â‚¬100 million budget, they'll score points based on their real-life performances.Unlimited transfers until the first match." }

                </div>
              </div>
              <div className="si-section__col">
                <div className="si-intro__img">
                  <img src={ imageBaseURL + "challenges.png?v=" + config.imgVersion } />
                </div>
                <div className="si-intro__head">
                  { trans[transPrefix + 'competeWithFriends'] || "Compete with friends" }
                </div>
                <div className="si-intro__desc">
                  { trans[transPrefix + 'createAndJoinPLeague'] || "Create and join private leagues to earn bragging rights among friends. You can also follow your global rank." }

                </div>
              </div>
              <div className="si-section__col">
                <div className="si-intro__img si-last__img">
                  <img src={ imageBaseURL + "prizes.png?v=" + config.imgVersion } />
                </div>
                <div className="si-intro__head">
                  { trans[transPrefix + 'winPrizInEachRound'] || "Win prizes in each round" }
                </div>
                <div className="si-intro__desc">
                  { trans[transPrefix + 'topMngrsWithChance'] || "The top managers will be in with a chance of winning match tickets and other exclusive prizes." }

                </div>
              </div>
            </div>
            <div className="si-section__row si-second">
              <div className="si-section__col">
                <div className="si-head si-head--tertiary">{ trans[transPrefix + 'readyToPlay'] || "Ready to play?" }</div>
                <div className="si-section__sub-head">{ trans[transPrefix + 'bringNxtChamp'] || "Bring the next Champions League matchday to life." }</div>

                <div className="si-btn__wrp">
                  {
                    (!cookie)
                      ?
                      <React.Fragment>
                        <div className="si-btn si-btn-primary" onClick={ this.onLogin }>{ trans[transPrefix + 'loginAndPlay'] || "Log in and play" }</div>
                        <div className="si-btn si-btn-secondary-wb" onClick={ () => { this.tryAsGuest(true) } }>{ trans[transPrefix + 'tryAsGuest'] || "Try as a guest" }</div>
                      </React.Fragment>
                      :
                      <div className="si-btn si-btn-primary" onClick={ () => { this.tryAsGuest() } }>{ trans[transPrefix + 'playFantasy'] || "PLAY FANTASY" }</div>

                  }
                </div>
                {/* <div className="si-bottom-ad si-web">
                  ad will come here
                </div> */}
                <div className="si-web">
                  {
                    (!config.isMobile)
                      ?
                      <AdBottom />
                      :
                      null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="si-section si-section--social">
          <div className="si-section--container">
            <div className="si-section__row">
              <div className="si-section__col">
                <div className="si-gaming__img" id="appSection">
                  <img src={ imageBaseURL + "gaming-hub-mob.png?v=" + config.imgVersion } className="si-mob" />
                  <img src={ imageBaseURL + "gaming-hub.png?v=" + config.imgVersion } className="si-web" />
                </div>
                <div className="si-head si-head--tertiary">{ trans[transPrefix + 'playToWinUCL'] || "Play to win with UCL Gaming Hub" }</div>
                <div className="si-section__desc">{ trans[transPrefix + 'joinFootballFans'] || "Join 1M+ football fans worldwide and compete in all 4 games. Start competing in" }
                </div>
                <div className="si-section__cta" >
                  <div className="si-share--img si-flexBox">
                    <a href="Javascript:void(0)" onClick={ this.goToPlayStore } className="si-share__link si-ps"></a>
                    <a href="Javascript:void(0)" onClick={ this.goToAppStore } className="si-share__link si-as"></a>
                  </div>
                  <div className="si-btn si-btn-primary" onClick={ () => { this.tryAsGuest() } }>{ trans[transPrefix + 'playNow'] || "play now" }</div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    trans: state.appData.trans,
    landingTrans: state.appData.landingTrans
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLandingTrans: () => { dispatch(getLandingTrans()) }
  }

};

export default (connect(mapStateToProps, mapDispatchToProps)(LandingPage))



// WEBPACK FOOTER //
// ./src/components/LandingPage.js